{
  "flows": {
    "ctaBannerMount": {
      "steps": [],
      "trigger": "lifecycle"
    },
    "navigateToSignup": {
      "steps": [
        {
          "action": "navigate",
          "params": {
            "route": "/signup"
          },
          "type": "basic"
        }
      ],
      "trigger": "event"
    }
  }
}
